<div class="loot-deck-dialog">
  <div class="scroll-container">
    <div class="menu" #menu>
      @if (deck.cards.length > 0) {
      <a (click)="reveal = (reveal + 1) % 3"><span [ghs-label]="reveal == 2 ? 'game.cards.coverAll' : (reveal == 0 ?
          'game.cards.revealAll' : 'game.cards.revealAllConfirm')"></span></a>
      <a ghs-pointer-input (singleClick)="shuffle()" (doubleClick)="shuffle(true)"
        [ghs-tooltip]="'game.cards.shuffle.upcomingHint'" [overlayX]="'center'"><span
          [ghs-label]="'game.cards.shuffle'"></span></a>
      <label><input type="checkbox" (click)="toggleEdit()" [checked]="edit"><span
          [ghs-label]="'game.cards.edit'"></span></label>
      @if (edit) {
      <a class="toggle-config" (click)="configuration = !configuration; enhancements = false"><img class="ghs-svg"
          src="./assets/images/settings.svg">
        <span [ghs-label]="'game.loot.config.' + (configuration ? 'hide' :
          'show')"></span></a>
      }
      }
      <a class="toggle-enhancements" (click)="toggleEnhancements()"><img class="ghs-svg"
          [src]="'./assets/images/fh/loot/' + (enhancements ?  'money' : 'plus1') + '.svg'">
        <span
          [ghs-label]="('game.loot.' + (enhancements && gameManager.game.scenario ? 'deck' : 'enhancements'))"></span></a>

      @if (enhancements) {
      <label>
        <input type="checkbox" (click)="toggleSpecial(LootType.special1)"
          [checked]="gameManager.game.lootDeckFixed.includes(LootType.special1)">
        <span [ghs-label]="'game.loot.toggleSpecial'" [ghs-label-args]="[LootType.special1]"></span>
      </label>
      <label>
        <input type="checkbox" (click)="toggleSpecial(LootType.special2)"
          [checked]="gameManager.game.lootDeckFixed.includes(LootType.special2)">
        <span [ghs-label]="'game.loot.toggleSpecial'" [ghs-label-args]="[LootType.special2]"></span>
      </label>
      }
    </div>
    @if (configuration) {
    <div class="config">
      <label class="title"><span [ghs-label]="'game.loot.config'"></span></label>
      <div class="values">
        @for (type of types; track type) {
        <label><img class="ghs-svg"
            [src]="'./assets/images/fh/loot/' + (type == LootType.special1 || type == LootType.special2 ? LootType.money : type) + '.svg'">
          <span [ghs-label]="'game.loot.' + type"></span></label>
        <a class="button"
          [ngClass]="{'disabled' : !lootDeckConfig[type] || type == LootType.random_item && gameManager.lootManager.randomItemLooted()}"
          (click)="changeType(type, -1)">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </a>
        <span class="value" [ghs-label]="'game.loot.' + type" [ghs-label-attribute]="'title'">
          {{lootDeckConfig[type] && 'x' + lootDeckConfig[type] || '-'}}
        </span>
        <a class="button"
          [ngClass]="{'disabled' : lootDeckConfig[type] == maxValue(type) || type == LootType.random_item && gameManager.lootManager.randomItemLooted()}"
          (click)="changeType(type,  1)">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </a>
        }
      </div>
      <div class="config-menu">
        @if (deck.cards.length > 0) {
        <a (click)="currentConfig()"><span [ghs-label]="'game.loot.config.discard'"></span></a>
        }
        <a (click)="applyConfig()">
          <span [ghs-label]="('game.loot.config.' + (deck.cards.length == 0 ? 'create': 'apply'))"></span>
        </a>
      </div>
    </div>
    }

    @if (enhancements) {
    <div class="enhancements">
      @for (loot of enhancementDeck | trackUUID; track loot._trackUUID) {
      <div class="loot-container">
        <ghs-loot class="drag-hidden" [loot]="loot" [flipped]="true" [highlight]="false" [apply]="apply">
        </ghs-loot>
        <a class="button-enhance" (click)="enhanceCard(loot)" [ghs-label]="'game.loot.enhancements.add'"
          [ghs-label-attribute]="'title'">
          <img class="ghs-svg" src="./assets/images/fh/loot/plus1.svg">
        </a>
        @if (loot.enhancements > 0) {
        <div class="remove-enhancements">
          @for (i of [] | ghsRange:loot.enhancements; track i) {
          <img class="ghs-svg" (click)="unenhanceCard(loot)" src="./assets/images/fh/loot/plus1.svg"
            [ghs-label]="'game.loot.enhancements.remove'" [ghs-label-attribute]="'title'">
          }
        </div>
        }
      </div>
      }
    </div>
    }

    @if (!configuration && !enhancements) {
    <div class="loot-deck-container" [style.maxHeight]="maxHeight">
      <div class="upcoming drop-list" cdkDropList [cdkDropListDisabled]="!edit" #upcomingList="cdkDropList"
        [cdkDropListConnectedTo]="discardedList" (cdkDropListDropped)="dropUpcoming($event)"
        [cdkDropListAutoScrollStep]="20">
        @if (upcomingCards.length == 0) {
        <div class="empty"></div>
        }
        @for (loot of upcomingCards | trackUUID; track loot._trackUUID; let index = $index) {
        <div class="loot-container" cdkDrag>
          <ghs-loot class="drag-hidden" [loot]="loot" [reveal]="true" [flipped]="reveal == 2"
            [index]="deck.current + index +1" [character]="getCharacter(deck.current + index +1)" [apply]="apply">
          </ghs-loot>
          @if (edit) {
          <a class="button-remove" (click)="remove(index + deck.current + 1)">
            <img class="ghs-svg" src="./assets/images/minus.svg"></a>
          }
          @if (edit) {
          <div cdkDragHandle class="drag-handle"></div>
          }
        </div>
        }
      </div>
      <div class="discarded drop-list" cdkDropList [cdkDropListDisabled]="!edit" #discardedList="cdkDropList"
        [cdkDropListConnectedTo]="upcomingList" (cdkDropListDropped)="dropDiscarded($event)"
        [cdkDropListAutoScrollStep]="20">
        <div class="empty"></div>
        @for (loot of discardedCards | trackUUID; track loot._trackUUID; let index = $index) {
        <div class="loot-container" cdkDrag>
          <ghs-loot class="drag-hidden" [loot]="loot" [flipped]="true" [index]="deck.current - index"
            [character]="getCharacter(deck.current - index)" [edit]="edit" [looted]="true" [apply]="apply"></ghs-loot>
          @if (edit) {
          <a class="button-remove" (click)="remove(deck.current - index)">
            <img class="ghs-svg" src="./assets/images/minus.svg"></a>
          }
          @if (edit) {
          <div cdkDragHandle class="drag-handle"></div>
          }
        </div>
        }
      </div>
    </div>
    }
  </div>
</div>